import type { RunSummary, StepSummary } from "../../../workflows-api";

export function workflowDisplayLabel(run: Pick<RunSummary, "workflowName" | "workflowShortName">, definitions: readonly { name: string; label: string }[] = []): string {
  return definitions.find((definition) => definition.name === run.workflowName)?.label?.trim() || run.workflowShortName;
}

export function stepDisplayLabel(step: Pick<StepSummary, "stepShortName" | "tree">): string {
  return step.tree?.at(-1)?.label?.trim() || step.stepShortName;
}
